import * as Yup from 'yup';

export const patientSchema = Yup.object().shape({
  name: Yup.string().min(3, 'Nome muito curto').required('Digite o nome completo'),
  document: Yup.string().required('Digite o documento'),
  citizenship: Yup.string().required('Selecione a nacionalidade'),
  birthDateDate: Yup.string().min(10, 'Data inválida').required('Digite a data de nascimento'),
  phone: Yup.string().min(13, 'Digite um telefone válido').required('Digite o número de telefone'),
  email: Yup.string().min(3, 'muito curto').required('Digite o Email')
});
